module.exports = __webpack_public_path__ + "static/Grupo 127-17fed802ab01b974fe9f38f6e29d5fc0.png";